import { useEffect } from "react";
import discountAgreementActions from "../../../Actions/Voss/discountAgreementActions";
import customerDiscountAgreementActions from "../../../Actions/Voss/customerDiscountAgreementActions";
import CreateCustomerDiscountAgreementForm from "../../Customer/VOSS/Discounts/CreateCustomerDiscountAgreementForm";
import StandardModal from "../../Fundamentals/Modal/StandardModal";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import forms from "../../../Constants/forms";
import formActions from "../../../Actions/formActions";
import useModal from "../../../Hooks/useModal";
import * as formValidationRules from '../../../Constants/formValidationRules'

export default function CreateCustomerDiscountAgreementModal({ }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { closeModal } = useModal();
    const form = useSelector(state => state.FormReducer.forms[forms.createCustomerDiscountAgreement]);
    const customer = useSelector(state => state.CustomerReducer.customer.vossCustomer);
    const groupedDiscountAgreements = useSelector(state => state.DiscountAgreementsReducer.groupedDiscountAgreements);
    
    const isLoading = useSelector(state => 
        state.CommonReducer.dataLoading.createCustomerDiscountAgreement || 
        state.CommonReducer.dataLoading.getGroupedDiscountAgreements
    );

    useEffect(() => {
        dispatch(discountAgreementActions.getGroupedDiscountAgreements());
        dispatch(formActions.startFormEditing(forms.createCustomerDiscountAgreement, {}, formValidationRules.CreateCustomerDiscountAgreement));

        return () => {
            dispatch(formActions.cancelFormEditing(forms.createCustomerDiscountAgreement));
        }
    }, []);

    const onChange = (value, key) => {
        dispatch(formActions.changeMultiFormField(form, key, value));
    }

    const onSubmit = () => {
        dispatch(formActions.submitForm(form, () => {
            dispatch(customerDiscountAgreementActions.createCustomerDiscountAgreement(customer.id, form, () => {
                dispatch(customerDiscountAgreementActions.getCustomerDiscountAgreements(customer.id));
                closeModal();
            }));
        }));
    }

    return <StandardModal isLoading={isLoading} onSubmit={onSubmit} title={t("createCustomerDiscountAgreementModal.title")} >
        <CreateCustomerDiscountAgreementForm form={form} onChange={onChange} groupedDiscountAgreements={groupedDiscountAgreements} />
    </StandardModal>;
}